import { useState, useEffect } from 'react';

interface FormCache {
    currentStep: number;
    selectedService: any;
    describeFormData: any;
    contactFormData: any;
}

const defaultFormCache: FormCache = {
    currentStep: 1,
    selectedService: null,
    describeFormData: {},
    contactFormData: { isMoreProviders: true }
};

export const useFormCache = <T = any>(app: boolean = false) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [selectedService, setSelectedService] = useState<T | null>(null);
    const [describeFormData, setDescribeFormData] = useState<any>({});
    const [contactFormData, setContactFormData] = useState<any>({
        isMoreProviders: true
    });

    useEffect(() => {
        if (!app) return;

        const isFormCache = sessionStorage.getItem('isFormCache');
        const formCacheStr = sessionStorage.getItem('formCache');
        if (isFormCache === 'true' && formCacheStr) {
            try {
                const formCache = JSON.parse(formCacheStr);
                setCurrentStep(formCache.currentStep ?? 1);
                setSelectedService(formCache.selectedService ?? null);
                setDescribeFormData(formCache.describeFormData ?? {});
                setContactFormData(formCache.contactFormData ?? { isMoreProviders: true });
                return;
            } catch (e) {
                console.error('Error parsing form cache:', e);
            }
        }
        sessionStorage.setItem('isFormCache', 'true');
        sessionStorage.setItem('formCache', JSON.stringify(defaultFormCache));
        setCurrentStep(1);
        setSelectedService(null);
        setDescribeFormData({});
        setContactFormData({ isMoreProviders: true });
    }, [app]);

    useEffect(() => {
        if (!app) return;

        const formCache = {
            currentStep,
            selectedService,
            describeFormData,
            contactFormData
        };
        sessionStorage.setItem('formCache', JSON.stringify(formCache));
    }, [app, currentStep, selectedService, describeFormData, contactFormData]);

    return {
        currentStep,
        setCurrentStep,
        selectedService,
        setSelectedService,
        describeFormData,
        setDescribeFormData,
        contactFormData,
        setContactFormData
    };
};
